import { render, staticRenderFns } from "./ConsentBot.vue?vue&type=template&id=6fe7a5e4&scoped=true&lang=html&"
import script from "./ConsentBot.vue?vue&type=script&lang=js&"
export * from "./ConsentBot.vue?vue&type=script&lang=js&"
import style0 from "./ConsentBot.vue?vue&type=style&index=0&id=6fe7a5e4&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe7a5e4",
  null
  
)

export default component.exports